import { gql } from '@apollo/client';
import { Checkbox, Col, Form, Row, Select, Slider, Input, Alert } from 'antd';
import Modal from 'components/Modal';
import { useMutation } from 'hooks/apollo';
import useUser from 'hooks/useUser';
import React, { useEffect } from 'react';

const { TextArea } = Input;

const temperatureMarks = {
  0: {
    style: {
      color: '#05f',
    },
    label: <strong>0</strong>,
  },
  1: '1',
  2: {
    style: {
      color: '#f50',
    },
    label: <strong>2</strong>,
  },
};

const autoTagDefaultValues = {
  temperature: 0.5,
  sentiment: true,
  translate: true,
};

const TAG_COMMENTS = gql`
  mutation($input: AutoTagCommentsInput!) {
    autoTagComments(input: $input)
  }
`;

const AutoTagComments = ({ open, onCancel, onDone, tags, sentiments, questionIds, questionResponseIds }) => {
  const { isSuperUser } = useUser();
  const [form] = Form.useForm();
  const [tagMutation, { loading }] = useMutation(TAG_COMMENTS);

  useEffect(() => {
    form.setFieldValue('tagIds', tags.map((tag) => tag.id));
  }, [tags]);

  const onSubmit = async (values) => {
    const input = {
      ...values,
      questionIds,
      questionResponseIds,
      sentimentIds: values.sentiment ? sentiments.map((sentiment) => sentiment.id) : null,
    };
    await tagMutation({ variables: { input } });
    onDone();
  };

  return (
    <Modal open={open} onCancel={onCancel} title="Auto tag comments" okText={`Tag ${questionResponseIds.length} responses`} onOk={form.submit} confirmLoading={loading}>
      <Form form={form} layout="vertical" initialValues={autoTagDefaultValues} onFinish={onSubmit}>
        <Form.Item>
          <Alert message="This will send the text responses to an external service. It will overwrite any previously auto generated tags. The process will take a while and run in the background." type="warning" showIcon />
        </Form.Item>
        <Form.Item name="tagIds" label={`Tags (${tags.length})`} rules={[{ required: true, message: 'Select atleast one tag' }]}>
          <Select options={tags.map((theme) => ({ value: theme.id, label: theme.text }))} mode="multiple" allowClear />
        </Form.Item>
        <Row gutter={16}>
          <Col>
            <Form.Item name="sentiment" valuePropName="checked">
              <Checkbox>Sentiment analysis</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="translate" valuePropName="checked">
              <Checkbox>Translate to English</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="temperature" label="Temperature">
          <Slider marks={temperatureMarks} min={0} max={2} step={0.1} />
        </Form.Item>
        {isSuperUser && (
        <Form.Item name="customInstructions" label="Custom instructions">
          <TextArea autoSize={{ minRows: 3 }} />
        </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default AutoTagComments;
